/**
 * Where this widget keeps its two pieces of state.
 *
 * `tempWidgetProps` is a NESTED slice rather than flat props, for three reasons:
 *   - switching temp widget is one deleteVal, not a hunt for stale keys;
 *   - a temp widget can name its props whatever it likes without colliding
 *     with the container's own keys or another temp widget's;
 *   - it gives each temp widget a config object shaped exactly like a
 *     top-level widget's, so its processRawConfigFn / someReqPropsUnset /
 *     ConfigForm can be written the way every other widget's already are.
 */
export const TEMP_WIDGET_PROPS_KEY = "tempWidgetProps";

export const DATA_KEYS = {
  tempWidget: "props.tempWidget",
  tempWidgetProps: `props.${TEMP_WIDGET_PROPS_KEY}`,
};
